<template lang="pug">
.lessonPageComponent
  ui-loader(v-if="isLoading")
  .lessonContent(v-else)
    lesson-background(:subject="subject")
    .iframeWrapper
      iframe(
        ref="iframeRef"
        :src="lesson.iframeUrl + '?auto_load=false'"
        loading="lazy"
      )
</template>

<script>
import { computed, onUnmounted, ref, watch } from '@vue/runtime-core'
import LessonBackground from '@/components/Lesson/LessonBackground'
import ChildBookLessonController from '@/controllers/ChildBook/ChildBookLessonController'
import ChildBookContentsController from '@/controllers/ChildBook/ChildBookContentsController'
import router from '@/router'

export default {
  components: {
    LessonBackground
  },
  props: {
    lessonId: {
      type: Number,
      required: true
    }
  },
  setup (props) {
    const { lesson, requestLesson, isLoading, initIframeListener, destroyIframeListener, $on, $off } = ChildBookLessonController()
    requestLesson(props.lessonId)

    const exit = () => { router.push({ name: 'Book', params: { id: lesson.value.bookId } }) }

    const { childBook, setBookId } = ChildBookContentsController()
    watch(lesson, lesson => setBookId(lesson.bookId))

    const subject = computed(() => childBook.value?.userItem.book.subject ?? null)

    const iframeRef = ref(null)

    watch(isLoading, () => {
      // initialize iframe
      setTimeout(() => { initIframeListener(iframeRef.value) }, 0)
    })

    $on('iframe-close-click', exit)

    onUnmounted(() => {
      destroyIframeListener()
      $off('iframe-close-click', exit)
    })

    return { lesson, isLoading, subject, iframeRef }
  }
}
</script>

<style lang="sass" scoped>
.lessonPageComponent
  position: fixed
  width: 100vw
  height: 100%
  top: 0
  left: 0
  background-color: $cBackground
  z-index: $zIndexPlayerIframe

  > .lessonContent
    height: 100%

    > .iframeWrapper
      width: 100%
      height: 100%

      > iframe
        width: 100%
        height: 100%
</style>
